import { ReactElement } from 'react';
import styles from './Container.module.css';
import cn from 'clsx';

export interface ContainerProps {
    children?: any;
    className?: string;
    topL?: boolean;
    topR?: boolean;
    bottomL?: boolean;
    bottomR?: boolean;

}
export const Container = ({ children, className, topL = true, topR = true, bottomL = true, bottomR = true }: ContainerProps) => {
    const cls = cn(styles.container, {
        [styles.tl]: topL,
        [styles.tr]: topR,
        [styles.bl]: bottomL,
        [styles.br]: bottomR,
    }, className);
    return (
        <div className={cls}>
            {children}
        </div>
    )
}